import axios from 'axios';
import { getToken } from './utils/api/helpers';
const normalizeApiUrl = (url) => url.trim().replace(/\/+$/, '');
const OUVIDORIA_API_URL = normalizeApiUrl(process.env.REACT_APP_BASE_API_URL_OUVIDORIA || 'http://localhost:5214');
// Usa uma instancia separada para nao herdar auth e redirects do backend principal.
const ouvidoriaApi = axios.create({
    baseURL: OUVIDORIA_API_URL,
    headers: {
        Accept: 'application/json',
    },
});
ouvidoriaApi.interceptors.request.use(config => {
    const token = getToken();
    if (token) {
        config.headers = {
            ...(config.headers || {}),
            Authorization: `Bearer ${token}`,
        };
    }
    return config;
});
const buildMotivoOuvidoriaPayload = (payload, id) => ({
    id: id !== undefined ? Number(id) : Number(payload.id ?? 0),
    nomeMotivo: String(payload.nomeMotivo || '').trim(),
    descricao: String(payload.descricao || '').trim(),
    dataCriacao: payload.dataCriacao || new Date().toISOString(),
});
const buildTagOuvidoriaPayload = (payload, id) => ({
    id: id !== undefined ? Number(id) : Number(payload.id ?? 0),
    nomeTag: String(payload.nomeTag || '').trim(),
    descricao: String(payload.descricao || '').trim(),
    dataCriacao: payload.dataCriacao || new Date().toISOString(),
    prioridade: typeof payload.prioridade === 'boolean' ? payload.prioridade : false,
});
const buildFilialOuvidoriaPayload = (payload) => ({
    nomeFilial: String(payload.nomeFilial || '').trim(),
});
const normalizeOptionalNumber = (value) => {
    if (value === undefined || value === null || value === '') {
        return undefined;
    }
    const parsedValue = Number(value);
    return Number.isNaN(parsedValue) ? undefined : parsedValue;
};
const normalizeOptionalBoolean = (value) => {
    if (value === undefined || value === null || value === '') {
        return undefined;
    }
    if (typeof value === 'boolean') {
        return value;
    }
    if (typeof value === 'string') {
        if (value.toLowerCase() === 'true')
            return true;
        if (value.toLowerCase() === 'false')
            return false;
    }
    return undefined;
};
const buildCreateOuvidoriaPayload = (payload) => ({
    motivoId: Number(payload.motivoId || 0),
    relato: String(payload.relato || '').trim(),
    desejaAcompanhar: normalizeOptionalBoolean(payload.desejaAcompanhar),
    relatadoLiderStatus: normalizeOptionalNumber(payload.relatadoLiderStatus),
    statusAtual: normalizeOptionalNumber(payload.statusAtual),
    tags: Array.isArray(payload.tags)
        ? payload.tags
            .map(tag => ({
            tagId: Number(tag?.tagId || 0),
        }))
            .filter(tag => tag.tagId > 0)
        : [],
});
const buildUpdateOuvidoriaPayload = (payload) => ({
    motivoId: Number(payload.motivoId || 0),
    relato: String(payload.relato || '').trim(),
    desejaAcompanhar: normalizeOptionalBoolean(payload.desejaAcompanhar),
    relatadoLiderStatus: normalizeOptionalNumber(payload.relatadoLiderStatus),
    statusAtual: normalizeOptionalNumber(payload.statusAtual),
    protocolo: payload.protocolo ? String(payload.protocolo).trim() : '',
    telefone: payload.telefone !== undefined ? String(payload.telefone || '').trim() : undefined,
    filialId: normalizeOptionalNumber(payload.filialId),
});
const buildCreateMensagemOuvidoriaPayload = (payload) => ({
    ouvidoriaId: Number(payload.ouvidoriaId || 0),
    usuarioCriacao: payload.usuarioCriacao ? String(payload.usuarioCriacao).trim() : '',
    mensagem: payload.mensagem ? String(payload.mensagem).trim() : '',
    descricao: payload.descricao ? String(payload.descricao).trim() : '',
});
const buildCreateOuvidoriaMedidaPayload = (payload) => ({
    ouvidoriaId: Number(payload.ouvidoriaId || 0),
    medidaTomada: payload.medidaTomada ? String(payload.medidaTomada).trim() : '',
    desconsiderado: normalizeOptionalBoolean(payload.desconsiderado),
    motivoDesconsiderado: payload.motivoDesconsiderado
        ? String(payload.motivoDesconsiderado).trim()
        : '',
    usuarioFinalizado: payload.usuarioFinalizado ? String(payload.usuarioFinalizado).trim() : '',
});
const normalizeOuvidoriaDashboardResponse = (data) => {
    const cards = data?.cards ?? data?.Cards ?? {};
    const tagsPrioridade = data?.tagsPrioridade ?? data?.TagsPrioridade ?? [];
    const graficoMensal = data?.graficoMensal ?? data?.GraficoMensal ?? {};
    const graficoDiario = data?.graficoDiario ?? data?.GraficoDiario ?? {};
    const filtrosAplicados = data?.filtrosAplicados ?? data?.FiltrosAplicados ?? {};
    return {
        cards: {
            naoLidas: Number(cards?.naoLidas ?? cards?.NaoLidas ?? 0),
            criadasHoje: Number(cards?.criadasHoje ?? cards?.CriadasHoje ?? 0),
            finalizadas: Number(cards?.finalizadas ?? cards?.Finalizadas ?? 0),
            emAnalise: Number(cards?.emAnalise ?? cards?.EmAnalise ?? 0),
        },
        tagsPrioridade: Array.isArray(tagsPrioridade)
            ? tagsPrioridade.map((item) => ({
                tagId: Number(item?.tagId ?? item?.TagId ?? 0),
                nomeTag: String(item?.nomeTag ?? item?.NomeTag ?? ''),
                quantidadeOuvidorias: Number(item?.quantidadeOuvidorias ?? item?.QuantidadeOuvidorias ?? 0),
            }))
            : [],
        graficoMensal: {
            janeiro: Number(graficoMensal?.janeiro ?? graficoMensal?.Janeiro ?? 0),
            fevereiro: Number(graficoMensal?.fevereiro ?? graficoMensal?.Fevereiro ?? 0),
            marco: Number(graficoMensal?.marco ?? graficoMensal?.Marco ?? 0),
            abril: Number(graficoMensal?.abril ?? graficoMensal?.Abril ?? 0),
            maio: Number(graficoMensal?.maio ?? graficoMensal?.Maio ?? 0),
            junho: Number(graficoMensal?.junho ?? graficoMensal?.Junho ?? 0),
            julho: Number(graficoMensal?.julho ?? graficoMensal?.Julho ?? 0),
            agosto: Number(graficoMensal?.agosto ?? graficoMensal?.Agosto ?? 0),
            setembro: Number(graficoMensal?.setembro ?? graficoMensal?.Setembro ?? 0),
            outubro: Number(graficoMensal?.outubro ?? graficoMensal?.Outubro ?? 0),
            novembro: Number(graficoMensal?.novembro ?? graficoMensal?.Novembro ?? 0),
            dezembro: Number(graficoMensal?.dezembro ?? graficoMensal?.Dezembro ?? 0),
        },
        graficoDiario: {
            dias: Array.isArray(graficoDiario?.dias ?? graficoDiario?.Dias)
                ? (graficoDiario?.dias ?? graficoDiario?.Dias).map((item) => ({
                    data: String(item?.data ?? item?.Data ?? ''),
                    quantidade: Number(item?.quantidade ?? item?.Quantidade ?? 0),
                }))
                : [],
        },
        filtrosAplicados: {
            dataInicial: filtrosAplicados?.dataInicial ?? filtrosAplicados?.DataInicial ?? '',
            dataFinal: filtrosAplicados?.dataFinal ?? filtrosAplicados?.DataFinal ?? '',
            ano: Number(filtrosAplicados?.ano ?? filtrosAplicados?.Ano ?? 0),
        },
    };
};
const hasQueryValue = (value) => {
    if (value === undefined || value === null)
        return false;
    if (typeof value === 'string')
        return value.trim() !== '';
    if (Array.isArray(value))
        return value.length > 0;
    return true;
};
const buildQueryParams = (params) => {
    if (!params)
        return undefined;
    return Object.fromEntries(Object.entries(params).filter(([, value]) => hasQueryValue(value)));
};
const buildPagedResponse = (data, pagina = 1, limitePorPagina = 20) => {
    const paginaNormalizada = Number(pagina) > 0 ? Number(pagina) : 1;
    const limiteNormalizado = Number(limitePorPagina) > 0 ? Number(limitePorPagina) : 20;
    if (Array.isArray(data)) {
        const totalItens = data.length;
        const inicio = (paginaNormalizada - 1) * limiteNormalizado;
        const fim = inicio + limiteNormalizado;
        const itensPaginados = data.slice(inicio, fim);
        return {
            itens: itensPaginados,
            paginacao: {
                pagina: paginaNormalizada,
                limitePorPagina: limiteNormalizado,
                totalItens,
                totalPaginas: totalItens > 0 ? Math.ceil(totalItens / limiteNormalizado) : 0,
            },
        };
    }
    const itens = Array.isArray(data?.itens)
        ? data.itens
        : Array.isArray(data?.Itens)
            ? (data.Itens ?? [])
            : [];
    const paginacaoData = data?.paginacao
        ?? data?.Paginacao;
    return {
        itens,
        paginacao: {
            pagina: Number(paginacaoData?.pagina
                ?? paginacaoData?.Pagina
                ?? paginaNormalizada),
            limitePorPagina: Number(paginacaoData
                ?.limitePorPagina
                ?? paginacaoData?.LimitePorPagina
                ?? limiteNormalizado),
            totalItens: Number(paginacaoData?.totalItens
                ?? paginacaoData?.TotalItens
                ?? 0),
            totalPaginas: Number(paginacaoData?.totalPaginas
                ?? paginacaoData?.TotalPaginas
                ?? 0),
        },
    };
};
export const getMotivosOuvidoria = async (params = {}) => {
    const response = await ouvidoriaApi.get('/motivos-ouvidoria', {
        params: buildQueryParams(params),
    });
    return buildPagedResponse(response?.data, params.pagina, params.limitePorPagina);
};
export const getMotivoOuvidoriaById = async (id) => {
    if (!id)
        throw new Error('ID do motivo da ouvidoria e obrigatorio');
    const response = await ouvidoriaApi.get(`/motivos-ouvidoria/${id}`);
    return response?.data || {};
};
export const createMotivoOuvidoria = async (payload) => {
    const response = await ouvidoriaApi.post('/motivos-ouvidoria', buildMotivoOuvidoriaPayload(payload));
    return response?.data || {};
};
export const updateMotivoOuvidoria = async (id, payload) => {
    if (!id)
        throw new Error('ID do motivo da ouvidoria e obrigatorio');
    const response = await ouvidoriaApi.put(`/motivos-ouvidoria/${id}`, buildMotivoOuvidoriaPayload(payload, id));
    return response?.data || {};
};
export const deleteMotivoOuvidoria = async (id) => {
    if (!id)
        throw new Error('ID do motivo da ouvidoria e obrigatorio');
    const response = await ouvidoriaApi.delete(`/motivos-ouvidoria/${id}`);
    return response?.data || {};
};
export const getTagsOuvidoria = async (params = {}) => {
    const response = await ouvidoriaApi.get('/tags-ouvidoria', {
        params: buildQueryParams(params),
    });
    return buildPagedResponse(response?.data, params.pagina, params.limitePorPagina);
};
export const getTagOuvidoriaById = async (id) => {
    if (!id)
        throw new Error('ID da tag da ouvidoria e obrigatorio');
    const response = await ouvidoriaApi.get(`/tags-ouvidoria/${id}`);
    return response?.data || {};
};
export const createTagOuvidoria = async (payload) => {
    const response = await ouvidoriaApi.post('/tags-ouvidoria', buildTagOuvidoriaPayload(payload));
    return response?.data || {};
};
export const updateTagOuvidoria = async (id, payload) => {
    if (!id)
        throw new Error('ID da tag da ouvidoria e obrigatorio');
    const response = await ouvidoriaApi.put(`/tags-ouvidoria/${id}`, buildTagOuvidoriaPayload(payload, id));
    return response?.data || {};
};
export const deleteTagOuvidoria = async (id) => {
    if (!id)
        throw new Error('ID da tag da ouvidoria e obrigatorio');
    const response = await ouvidoriaApi.delete(`/tags-ouvidoria/${id}`);
    return response?.data || {};
};
export const getFiliaisOuvidoria = async (params = {}) => {
    const response = await ouvidoriaApi.get('/filiais-ouvidoria', {
        params: buildQueryParams(params),
    });
    return buildPagedResponse(response?.data, params.pagina, params.limitePorPagina);
};
export const getFilialOuvidoriaById = async (id) => {
    if (!id)
        throw new Error('ID da filial da ouvidoria e obrigatorio');
    const response = await ouvidoriaApi.get(`/filiais-ouvidoria/${id}`);
    return response?.data || {};
};
export const createFilialOuvidoria = async (payload) => {
    const response = await ouvidoriaApi.post('/filiais-ouvidoria', buildFilialOuvidoriaPayload(payload));
    return response?.data || {};
};
export const updateFilialOuvidoria = async (id, payload) => {
    if (!id)
        throw new Error('ID da filial da ouvidoria e obrigatorio');
    const response = await ouvidoriaApi.put(`/filiais-ouvidoria/${id}`, buildFilialOuvidoriaPayload(payload));
    return response?.data || {};
};
export const deleteFilialOuvidoria = async (id) => {
    if (!id)
        throw new Error('ID da filial da ouvidoria e obrigatorio');
    const response = await ouvidoriaApi.delete(`/filiais-ouvidoria/${id}`);
    return response?.data || {};
};
export const getOuvidorias = async (params = {}) => {
    const response = await ouvidoriaApi.get('/ouvidoria', {
        params: buildQueryParams(params),
    });
    return buildPagedResponse(response?.data, params.pagina, params.limitePorPagina);
};
export const getOuvidoriaById = async (id) => {
    if (!id)
        throw new Error('ID da ouvidoria e obrigatorio');
    const response = await ouvidoriaApi.get(`/ouvidoria/${id}`);
    return response?.data || {};
};
export const getOuvidoriaByProtocolo = async (protocolo) => {
    if (!protocolo)
        throw new Error('Protocolo da ouvidoria e obrigatorio');
    const response = await ouvidoriaApi.get(`/ouvidoria/protocolo/${encodeURIComponent(protocolo)}`);
    return response?.data || {};
};
export const createOuvidoria = async (payload) => {
    const response = await ouvidoriaApi.post('/ouvidoria', buildCreateOuvidoriaPayload(payload));
    return response?.data || {};
};
export const updateOuvidoria = async (id, payload) => {
    if (!id)
        throw new Error('ID da ouvidoria e obrigatorio');
    const response = await ouvidoriaApi.put(`/ouvidoria/${id}`, buildUpdateOuvidoriaPayload(payload));
    return response?.data || {};
};
export const deleteOuvidoria = async (id) => {
    if (!id)
        throw new Error('ID da ouvidoria e obrigatorio');
    const response = await ouvidoriaApi.delete(`/ouvidoria/${id}`);
    return response?.data || {};
};
export const getMensagensOuvidoria = async (params = {}) => {
    const response = await ouvidoriaApi.get('/mensagens-ouvidoria', {
        params: buildQueryParams(params),
    });
    return buildPagedResponse(response?.data, params.pagina, params.limitePorPagina);
};
export const createMensagemOuvidoria = async (payload) => {
    const response = await ouvidoriaApi.post('/mensagens-ouvidoria', buildCreateMensagemOuvidoriaPayload(payload));
    return response?.data || {};
};
export const createOuvidoriaMedida = async (payload) => {
    const response = await ouvidoriaApi.post('/ouvidoria-medidas', buildCreateOuvidoriaMedidaPayload(payload));
    return response?.data || {};
};
export const getOuvidoriaDashboard = async (payload = {}) => {
    const response = await ouvidoriaApi.post('/ouvidoria/dashboard', {
        dataInicial: payload.dataInicial || undefined,
        dataFinal: payload.dataFinal || undefined,
        ano: payload.ano || undefined,
    });
    return normalizeOuvidoriaDashboardResponse(response?.data);
};
